import { deleteFromLocal, saveTolocal } from "../../Services/UserAuth";
export const loginUserAction = (state, action) => {
	state.isLoggedin = true;
	state.userData = action.payload.userData;
	state.accessToken = action.payload.accessToken;
	saveTolocal('accessToken', action.payload.accessToken);
}

export const logoutUserAction = (state) => {
	state.isLoggedin = false;
	state.userData = {};
	state.accessToken = "";
	state.loggingOut = true;
	deleteFromLocal('accessToken');
	window.location.reload();
}
export const setAccessTokenAction = (state, action) => {
	state.accessToken = action.payload
	saveTolocal('accessToken', action.payload);
}
export const setRolesAction = (state, action) => {
	state.rolesList = action.payload
}
export const setCapsAction = (state, action) => {
	state.capsList = action.payload
}